import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SEOService } from '@box-core/services';

type PromoData = {
  name: string;
  texts: string[];
  ctaText: string;
  tabTitle: string;
  url: string;
  img: PromoDataImg;
  pageTitle: string;
};

type PromoDataImg = { src: string; srcSet: string; alt: string };

const blast_1 =
  'Με κάθε παραγγελία από τα χιλιάδες καταστήματα που συμμετέχουν στο BOX BLAST, <b>κερδίζεις 3€ κουπόνι</b>, ξανά και ξανά!';
const blast_2 =
  'Γράψε <b>BOXBLAST</b> στην εξαργύρωση κουπονιού κατά την ολοκλήρωση της 1ης παραγγελίας, κέρδισε απευθείας 3€ έκπτωση καθώς και νέο 3€ κουπόνι για την επόμενη παραγγελία σου! 🎁';
const blast_3 = 'Και απόλαυση και οικονομία, στο delivery app που πάντα κερδίζεις!';
const blast_4 = 'Τα κουπόνια σου θα τα βρεις πατώντας πάνω δεξιά, εκεί που αναγράφονται οι πόντοι σου. 🤩';
const blast_5 =
  '<span style="font-size:0.875rem; font-style: italic;">🕑 *Ισχύει για παραγγελίες έως 31 Οκτωβρίου. Ελάχιστο ποσό παραγγελίας 8€. Το κουπόνι ισχύει για 3 ημέρες.</span>';

const blastData: PromoData = {
  name: 'Blast Page',
  texts: [blast_1, blast_2, blast_3, blast_4, blast_5],
  ctaText: 'order_now_exclamation',
  tabTitle: 'BLAST',
  pageTitle: 'Το BOX ΒLAST είναι πάλι εδώ για να κερδίζεις κάθε φορά που παραγγέλνεις!',
  url: '/blast',
  img: {
    src: 'https://w4ve.s3.eu-central-1.amazonaws.com/box/configuration/images/@3xΒΟΧBlastLP.png',
    srcSet:
      'https://w4ve.s3.eu-central-1.amazonaws.com/box/configuration/images/@1xΒΟΧBlastLP.png 1x, https://w4ve.s3.eu-central-1.amazonaws.com/box/configuration/images/@2xΒΟΧBlastLP.png 2x, https://w4ve.s3.eu-central-1.amazonaws.com/box/configuration/images/@3xΒΟΧBlastLP.png 3x',
    alt: 'BOX Blast'
  }
};

@Component({
  selector: 'blast-page',
  templateUrl: './blast.page.html',
  styleUrls: ['./blast.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlastPage implements OnInit {
  public description: string;
  public ctaText: string;
  public src: string;
  public srcSet: string;
  public alt: string;
  public texts: string[];
  public pageTitle: string;

  constructor(private seoService: SEOService) {}

  ngOnInit(): void {
    const data = blastData as PromoData;
    this.texts = data.texts;
    this.ctaText = data.ctaText;
    this.src = data.img.src;
    this.srcSet = data.img.srcSet;
    this.alt = data.img.alt;
    this.pageTitle = data.pageTitle;
    const options = { title: data.tabTitle, description: this.description, url: data.url };
    this.seoService.setTags(options);
  }
}
